// validationUtils.js

import AlertMessage from "../AlertMessage";

export const validateField = (name, value, alertShowMessage) => {
  let errorMessage = "";

  switch (name) {
    case "agencyName":
    case "shortName":
    case "contactName":
    case "driverName":
    case "name":
      if (!/^[a-zA-Z\s]*$/.test(value)) {
        errorMessage = "Please Enter a Valid Name";
      } else if (value.length < 3) {
        errorMessage = "Name must be at least 3 characters";
      }
      break;
    case "vehicleNumber":
      if (!/^[a-zA-Z0-9]*$/.test(value)) {
        errorMessage = "Please Enter a Valid Vehicle Number";
      } else if (value.length < 3) {
        errorMessage = "Name must be at least 3 characters";
      }
      break;

    case "email":
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        errorMessage = "Please Enter a Valid Email";
      }
      break;

    case "MobileNumber":
      if (!/^\d{10}$/.test(value)) {
        errorMessage = "Please enter exactly 10 digits mobile number";
      }
      break;

    case "address":
      if (value.length < 3) {
        errorMessage = "Address must be at least 3 characters";
      }
      break;
      case "newpassword":
      case "confirmPassword":
        if (value.length < 7) {
          errorMessage = "password must be at least 8 characters";
        }
        break;
    case "weightLimit":
      if (value.length > 4) {
        errorMessage = "Please enter exactly 4 digits number";
      }
      break;

    default:
      break;
  }
  //     <AlertMessage
  //     open={alertShowMessage}
  //     setOpen={setAlertShowMessage}
  //     message={errorMessage}
  //     severity={alertShowMessage?.severity}
  //   />
  return errorMessage;
};
